var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightTakeoffCat6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.967,
    height: 26.488,
    viewBox: "0 0 29.967 26.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flight_takeoff_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24",
    d: "M67.511-804.121v-2.3H93.594v2.3Zm2.36-7.612L64.62-820.5l2.959-.791,4.193,3.546,5.857-1.537-7.748-10.365,3.653-.968,11.188,9.436,6.536-1.75a2.506,2.506,0,0,1,2,.265,2.574,2.574,0,0,1,1.232,1.6,2.58,2.58,0,0,1-.236,2,2.468,2.468,0,0,1-1.573,1.232Z",
    transform: "translate(-64.619 830.609)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightTakeoffCat6);
export default __webpack_public_path__ + "static/media/flight_takeoff_cat_6.dcc3a86fed45a9c8a33c435a4ac5de03.svg";
export { ForwardRef as ReactComponent };